import { render, staticRenderFns } from "./OtherInfoSection.vue?vue&type=template&id=a851f1a2&"
import script from "./OtherInfoSection.vue?vue&type=script&lang=js&"
export * from "./OtherInfoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports